module.exports = __webpack_public_path__ + "static/media/21.fb2cf58b.jpg";